import { render, staticRenderFns } from "./TabsCmp.vue?vue&type=template&id=6e53d6a8&scoped=true"
import script from "./TabsCmp.vue?vue&type=script&lang=js"
export * from "./TabsCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e53d6a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e53d6a8')) {
      api.createRecord('6e53d6a8', component.options)
    } else {
      api.reload('6e53d6a8', component.options)
    }
    module.hot.accept("./TabsCmp.vue?vue&type=template&id=6e53d6a8&scoped=true", function () {
      api.rerender('6e53d6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/TabsCmp.vue"
export default component.exports